export { default } from './CardsConfigView';
